module.exports = __webpack_public_path__ + "img/face-astonished.cc7c96f5.svg";